import BaseDB from 'libs/DB/BaseDB'

const logoDB = new BaseDB('logoDB', {
  version: 2,
  key: 'domain',
  dataKey: 'blob',
  expireDuration: 7 * 24 * 60 * 60 * 1000, // 만료 기간 7일.
  getSaveData: (item) => {
    return {
      ...item,
      url: item.blob != null ? window.URL.createObjectURL(item.blob) : null,
    }
  },
  beforeRemoveSaveData: (saveData) => {
    if (saveData != null && saveData.url != null) {
      window.URL.revokeObjectURL(saveData.url)
    }
  },
})

export default logoDB
